import { Chip } from '@mui/material'
import translate from '../../i18n/translate'
import { RobotSmsDeclarationStatus } from '../../modules/services/robotSmsPolicyService'

const STATUS_COLORS: Record<RobotSmsDeclarationStatus, 'warning' | 'success' | 'error' | 'default'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  revoked: 'default',
}

const DeclarationStatusChip = ({ status }: { status: RobotSmsDeclarationStatus }) => (
  <Chip size="small" color={STATUS_COLORS[status]} label={translate(`robotSmsDeclarationStatus_${status}`)} />
)

export default DeclarationStatusChip
